enum OrganizationStatus {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  OUT_OF_BUSINESS = "OUT_OF_BUSINESS",
  ACQUIRED = "ACQUIRED",
  INTERNAL = "INTERNAL",
  INACTIVE = "INACTIVE"
}
export const TerminalStatus = [OrganizationStatus.ACQUIRED, OrganizationStatus.OUT_OF_BUSINESS];

export default OrganizationStatus;
